// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const dataTable = [
    {
        date: "1/5/2018",
        order: 1234504,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Submitted",
        po: 10000,
        total: 805.92,
    },
    {
        date: "1/4/2018",
        order: 1234503,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Shipped",
        po: 10000,
        total: 44.01,
    },
    {
        date: "1/3/2018",
        order: 1234502,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "RMA",
        po: 10000,
        total: 123.45,
    },
    {
        date: "1/2/2018",
        order: 1234501,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Complete",
        po: 10000,
        total: 44.01,
    },
    {
        date: "1/1/2018",
        order: 1234500,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Complete",
        po: 10000,
        total: 123.45,
    },
];

export const longText =
    "To obtain a price quote, add this item to your cart and select 'Request a Quote' from the cart page. You can request a quote for multiple items.";

export const dynamicDropdownOptions = [
    {
        optionText: "apple apple apple apple apple apple apple apple apple apple apple apple apple apple ",
        searchString: "rouge reed redd read",
    },
    { optionText: "orange", searchString: "orag", disabled: true },
    { optionText: "orangered", searchString: "orag" },
    { optionText: "yellow", searchString: "yelloe yeallow", disabled: true },
    { optionText: "green", searchString: "gren grreen grren" },
    { optionText: "blue" },
    { optionText: "indigo", searchString: "jean" },
    { optionText: "violet", searchString: "purple" },
];

export const dummyLinks = [
    {
        children: "Home",
        href: "https://home.insitesoft.com",
    },
    {
        children: "Category",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-1",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-2",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-3",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-4",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-5",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Current Page",
    },
];
